const  ENDPOINT = "https://admin.siliconmindstechnologies.com/";
export default ENDPOINT;




